
export const baseUrl = process.env.REACT_APP_API_LEVMILHAS;
export const basePath = process.env.REACT_APP_IMAGENS_BASE_PATH
// export const baseUrl = "http://189.44.65.252:443";
// export const basePath = "http://189.44.65.252:443/imagens";